<template>
  <div class="tw-flex tw-items-center">
    <input
      :id="id"
      type="checkbox"
      class="form-checkbox focus:tw-ring-primary-500 tw-h-4 tw-w-4 tw-text-primary-500 tw-border-gray-300 tw-rounded"
      @change="handleChange"
      :checked="isChecked"
      :disabled="disabled"
      :value="value"
    />
    <label :for="id" class="tw-font-thin tw-text-sm tw-ml-3 tw-mb-0" v-if="label || $slots.default">
      <slot>
        {{ label }}
      </slot>
    </label>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  model: {
    prop: "values",
    event: "input",
  },
  props: {
    label: String,
    values: { type: [Array, Boolean], default: false }, // Supports both arrays and booleans
    value: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      id: `checkbox-${uuidv4()}`,
    };
  },
  computed: {
    isChecked() {
      if (typeof this.values === "boolean") {
        return this.values; // If boolean, return as-is
      }
      return Array.isArray(this.values) && this.values.includes(this.value);
    },
  },
  methods: {
    handleChange(event) {
      if (typeof this.values === "boolean") {
        this.$emit("input", !this.values); // Toggle boolean value
        return;
      }

      if (!Array.isArray(this.values)) return;

      const val = event.target.value;
      const copy = [...this.values];
      const existingIndex = copy.indexOf(val);

      if (existingIndex >= 0) {
        copy.splice(existingIndex, 1);
      } else {
        copy.push(val);
      }

      this.$emit("input", copy);
    },
  },
};
</script>
